import {
  processAuthHeaders,
  processCrmAuthHeaders,
  getEnableSeamlessAuth,
} from '~/adapters/http/utils'

export default function (context) {
  context.$axios.create({
    headers: {
      common: {
        Accept: 'application/json, text/plain, */*',
      },
    },
  })

  // interceptor request
  context.$axios.onRequest((config) => {
    if (context.app.$auth.loggedIn) {
      const cookieObj = new URLSearchParams(
        document.cookie.replaceAll('&', '%26').replaceAll('; ', '&')
      )
      const token = cookieObj.get('qontak._token.hub')
      const enableSeamlessAuth = getEnableSeamlessAuth()
      if (enableSeamlessAuth) {
        let authHeaders = {}
        if (config.custom_metadata && config.custom_metadata.crm) {
          authHeaders = processCrmAuthHeaders({})
        } else {
          authHeaders = processAuthHeaders({})
        }
        Object.keys(authHeaders).forEach((key) => {
          context.$axios.setHeader(key, authHeaders[key])
        })
      }
      if (token && token.toLowerCase().startsWith('bearer ')) {
        context.$axios.setToken(token.replace(/^bearer\s+/i, ''), 'bearer')
      } else if (token) {
        context.$axios.setToken(token, 'bearer')
      }
    }
  })

  // interceptor response
  context.$axios.onResponse((_response) => {
    // do some logic
  })

  // interceptor error
  context.$axios.onError((_error) => {
    // do some logic
  })
}
